export default __webpack_public_path__ + "112cf4f9c5ded43dc30cda62ae1c72c3.png";